'use client';

import { useEffect, useState } from 'react';

import useProfile from '../useProfile';
import useLocalStorageState from '../useLocalStorageState';

import { ModalStatus } from '@/shared/types';
import { ONBOARDING_STATUS, STORAGE_KEY } from '@/shared/constants';

interface InitialModalStatus {
  onboarding: ModalStatus;
  marketing: ModalStatus;
  collection: ModalStatus;
}

const useInitialModalStatus = () => {
  const { profile } = useProfile();
  const [status, setStatus] = useState<InitialModalStatus>({
    onboarding: ModalStatus.PENDING,
    marketing: ModalStatus.PENDING,
    collection: ModalStatus.PENDING,
  });
  const [isShowMarketingModal] = useLocalStorageState(
    STORAGE_KEY.MARKETING,
    false
  );

  // 온보딩 모달 상태 구독 프로세스
  useEffect(() => {
    const getOnboardingStatus = () => {
      if (!profile || profile.yozmitOnboardingStatus === undefined) {
        return ModalStatus.PENDING;
      }

      return profile.yozmitOnboardingStatus < ONBOARDING_STATUS.END
        ? ModalStatus.IN_PROGRESS
        : ModalStatus.COMPLETED;
    };

    setStatus((prev) => ({
      ...prev,
      onboarding: getOnboardingStatus(),
    }));
  }, [profile]);

  // 마케팅 알림 설정 모달 상태 구독 프로세스
  useEffect(() => {
    if (isShowMarketingModal) {
      return setStatus((prev) => ({
        ...prev,
        marketing: ModalStatus.COMPLETED,
      }));
    }
  }, [isShowMarketingModal]);

  return { status };
};

export default useInitialModalStatus;
